(function (Translator) {
    // lt
    Translator.add("logout", "Atsijungti", "EvpAdministrationBundle", "lt");
    Translator.add("pagination.first", "Pirmas", "EvpAdministrationBundle", "lt");
    Translator.add("pagination.previous", "Atgal", "EvpAdministrationBundle", "lt");
    Translator.add("pagination.next", "Pirmyn", "EvpAdministrationBundle", "lt");
    Translator.add("pagination.last", "Paskutinis", "EvpAdministrationBundle", "lt");
    Translator.add("pagination.page_out_of", "i\u0161", "EvpAdministrationBundle", "lt");
    Translator.add("invalid_request", "Neteisinga u\u017eklausa", "EvpAdministrationBundle", "lt");
    Translator.add("invalid_parameters", "Blogi parametrai", "EvpAdministrationBundle", "lt");
    Translator.add("invalid_state", "Neteisinga b\u016bsena", "EvpAdministrationBundle", "lt");
    Translator.add("invalid_grant", "Prieiga nesuteikta", "EvpAdministrationBundle", "lt");
    Translator.add("invalid_code", "Neteisingas kodas", "EvpAdministrationBundle", "lt");
    Translator.add("unauthorized", "Prieiga nesuteikta", "EvpAdministrationBundle", "lt");
    Translator.add("forbidden", "Neleid\u017eiama", "EvpAdministrationBundle", "lt");
    Translator.add("not_found", "Nerasta", "EvpAdministrationBundle", "lt");
    Translator.add("rate_limit_exceeded", "Pasiektas limitas", "EvpAdministrationBundle", "lt");
    Translator.add("limits_exceeded", "Pasiektas limitas", "EvpAdministrationBundle", "lt");
    Translator.add("internal_server_error", "Serverio klaida", "EvpAdministrationBundle", "lt");
    Translator.add("not_acceptable", "Nepriimama", "EvpAdministrationBundle", "lt");
    Translator.add("administration.user_search_label", "Naudotojo ID", "EvpAdministrationBundle", "lt");
    Translator.add("administration.user_search_button", "Ie\u0161koti", "EvpAdministrationBundle", "lt");
})(Translator);
